import React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Button from "./Button";
import Input from "./Input";
import { COLORBAR_RANGE_MODE_OPTIONS } from "./colorbarConstants";
import RadioGroup from "./RadioGroup";
import "./colorBar.css";

const ColorbarSetRangeModal = ({
  category,
  subcategory,
  sliderMin,
  sliderMax,
  value,
  onValueChange,
  rangeMode,
  onRangeModeChange,
  step,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="colorbar-set-range-modal" role="dialog" aria-modal="true">
      <div className="colorbar-set-range-modal__header">
        <h2>{category}</h2>
        <h2>{subcategory}</h2>
      </div>

      <Box className="colorbar-set-range-modal__slider">
        <span>{sliderMin}</span>
        <Slider
          getAriaLabel={() => "Color scale range"}
          value={value}
          onChange={(_, newValue) => onValueChange(newValue)}
          min={sliderMin}
          max={sliderMax}
          valueLabelDisplay="off"
          step={step}
        />
        <span>{sliderMax}</span>
      </Box>

      <div className="colorbar-set-range-modal__inputs">
        <Input
          type="number"
          placeholder="Min"
          value={value[0]}
          onChange={(e) => onValueChange([e.target.value, value[1]])}
        />
        <span className="colorbar-set-range-modal__input-separator">-</span>
        <Input
          type="number"
          placeholder="Max"
          value={value[1]}
          onChange={(e) => onValueChange([value[0], e.target.value])}
        />
      </div>

      <RadioGroup
        name={`range-mode-${category}-${subcategory}`}
        value={rangeMode}
        onChange={onRangeModeChange}
        options={COLORBAR_RANGE_MODE_OPTIONS}
        className="colorbar-range-mode-selector"
        optionClassName="colorbar-range-mode-option"
      />

      <div className="colorbar-set-range-modal__actions">
        <Button variant="primary" onClick={onConfirm}>
          OK
        </Button>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default ColorbarSetRangeModal;
